import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _dec, _class, _class2;
/** @jsx jsx */
import t from 'format-message';
import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Link } from '@instructure/ui-link';
import { IconTrashLine, IconOutcomesLine, IconSubaccountsLine, IconCoursesLine, IconWarningLine } from '@instructure/ui-icons';
import { View } from '@instructure/ui-view';
import { withStyle, jsx } from '@instructure/emotion';
import OutcomeViewModal from "../OutcomeViewModal/index.js";
import generateComponentTheme from "../theme.js";
import generateStyle from "./styles.js";
import { stylesShape } from "../../store/shapes.js";
import { Pill } from '@instructure/ui-pill';
import { Tooltip } from '@instructure/ui-tooltip';
var Alignment = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(Alignment, _React$Component);
  var _super = _createSuper(Alignment);
  function Alignment() {
    var _this;
    _classCallCheck(this, Alignment);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.renderWithTooltip = function (Icon, color, text) {
      return jsx("span", {
        css: _this.props.styles.rightAligned
      }, jsx(Tooltip, {
        renderTip: t('To add this outcome, navigate to the Outcomes Management page.')
      }, jsx(Pill, {
        renderIcon: jsx(Icon, null),
        color: color,
        margin: "xxx-small"
      }, text)));
    };
    _this.renderWithoutTooltip = function (Icon, color, text) {
      return jsx("span", {
        css: _this.props.styles.rightAligned
      }, jsx(Pill, {
        renderIcon: jsx(Icon, null),
        color: color,
        margin: "xxx-small"
      }, text));
    };
    return _this;
  }
  _createClass(Alignment, [{
    key: "focus",
    value: function focus() {
      this.focusLink.focus();
    }
  }, {
    key: "getIcon",
    value: function getIcon(decorator, color) {
      if (color === 'danger') {
        return IconWarningLine;
      }
      return decorator !== null && decorator !== void 0 && decorator.includes('ACCOUNT') ? IconSubaccountsLine : IconCoursesLine;
    }
  }, {
    key: "getPillText",
    value: function getPillText(decorator, color) {
      if (color === 'danger') {
        return decorator !== null && decorator !== void 0 && decorator.includes('ACCOUNT') ? t('Not in this Sub-Account') : t('Not in this Course');
      }
      return decorator !== null && decorator !== void 0 && decorator.includes('ACCOUNT') ? t('Sub-Account Outcome') : t('Course Outcome');
    }
  }, {
    key: "renderOutcomeDecoration",
    value: function renderOutcomeDecoration(index, outcome) {
      var decorator = outcome.decorator;
      var display = ['SUB_ACCOUNT_OUTCOME', 'NOT_IN_SUB_ACCOUNT', 'COURSE_OUTCOME', 'NOT_IN_COURSE'].includes(decorator);
      var color = decorator !== null && decorator !== void 0 && decorator.startsWith('NOT_IN') ? 'danger' : 'primary';
      var Icon = this.getIcon(decorator, color);
      var text = this.getPillText(decorator, color);
      var renderFunction = color === 'danger' ? this.renderWithTooltip : this.renderWithoutTooltip;
      return display && renderFunction(Icon, color, text);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        index = _this$props.index,
        outcome = _this$props.outcome,
        removeAlignment = _this$props.removeAlignment,
        viewAlignment = _this$props.viewAlignment,
        closeAlignment = _this$props.closeAlignment,
        isOpen = _this$props.isOpen,
        artifactTypeName = _this$props.artifactTypeName,
        displayMasteryDescription = _this$props.displayMasteryDescription,
        displayMasteryPercentText = _this$props.displayMasteryPercentText,
        readOnly = _this$props.readOnly,
        scope = _this$props.scope;
      var removeMessage = t({
        default: 'Remove {title}',
        description: 'Screen reader caption for button that removes an alignment'
      }, {
        title: outcome.title
      });
      var itemStyle = [this.props.styles.item];
      if (index !== 0) {
        itemStyle.push(this.props.styles.itemSeparator);
      }
      return outcome.decorator !== 'HIDE' && jsx("li", {
        css: itemStyle,
        "data-automation": "outcomeAlignment__item"
      }, jsx("span", {
        css: this.props.styles.outcome
      }, jsx(Text, {
        size: "large"
      }, jsx(IconOutcomesLine, null))), jsx("span", {
        css: this.props.styles.link
      }, jsx("span", {
        css: this.props.styles.linkText
      }, jsx("span", {
        css: this.props.innerLinkText
      }, jsx(View, {
        as: "div",
        margin: "none none none xx-small"
      }, jsx(Link, {
        onClick: viewAlignment,
        ref: function ref(link) {
          _this2.focusLink = link;
        } // eslint-disable-line immutable/no-mutation
      }, jsx(Text, {
        weight: "bold",
        lineHeight: "condensed"
      }, outcome.title)), outcome.source_context_info && jsx(Text, {
        as: "div",
        weight: "light",
        size: "x-small",
        lineHeight: "condensed"
      }, outcome.source_context_info.name))))), this.renderOutcomeDecoration(index, outcome), !readOnly && jsx("span", {
        css: this.props.styles.rightAligned,
        "data-automation": "alignment-delete"
      }, jsx(IconButton, {
        screenReaderLabel: "",
        onClick: removeAlignment,
        withBorder: false,
        withBackground: false
      }, jsx(IconTrashLine, {
        title: removeMessage
      }))), jsx(OutcomeViewModal, {
        outcome: outcome,
        closeAlignment: closeAlignment,
        isOpen: isOpen,
        artifactTypeName: artifactTypeName,
        displayMasteryDescription: displayMasteryDescription,
        displayMasteryPercentText: displayMasteryPercentText,
        scope: scope
      }));
    }
  }]);
  Alignment.displayName = "Alignment";
  return Alignment;
}(React.Component), _class2.propTypes = {
  outcome: PropTypes.shape({
    label: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    in_launch_context: PropTypes.bool,
    launch_context_type: PropTypes.string,
    source_context_info: PropTypes.shape({
      name: PropTypes.string,
      context_type: PropTypes.string,
      uuid: PropTypes.string
    })
  }).isRequired,
  removeAlignment: PropTypes.func.isRequired,
  viewAlignment: PropTypes.func.isRequired,
  closeAlignment: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  artifactTypeName: PropTypes.string,
  displayMasteryDescription: PropTypes.bool,
  displayMasteryPercentText: PropTypes.bool,
  scope: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  styles: stylesShape
}, _class2.defaultProps = {
  artifactTypeName: null,
  displayMasteryDescription: false,
  displayMasteryPercentText: false
}, _class2)) || _class);
export { Alignment as default };